<template>
<main-content>
    <gateway-form :form_data="form_data" :submit="submit"></gateway-form>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import GatewayForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { gatewayService } from '@/common/api.service'

export default {
    components: {
        'main-content': mainContent,
        'gateway-form': GatewayForm
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.gateway.form_data
            },
            set: function(value) {
                this.$store.commit('gateway/setFormData', value)
            }
        }
    },
    methods: {
        submit(e) {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    merchant_type: {
                        required: true,
                    },
                    com_name_fa: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    com_name_en: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    national_legal_code: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_number: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    register_date: {
                        required: function(){
                            return $("#merchant_type").val() == 1;
                        }
                    },
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    subcategory_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    telephone: {
                        required: true
                    },
                    logo: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    merchant_share_percent: {
                        required: true
                    },
                    site_address: {
                        required: true,
                        url: true
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.$store.getters['gateway/form_data']
            gatewayService.create(params).then(response => {
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('gateway/clearFormData')
        })
    },
}
</script>

<style>

</style>